import m from "../../geodata/es2015/burundiLow";
window.am4geodata_burundiLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/burundiLow.js
// module id = null
// module chunks = 